import { Card, Divider, Icon, Typography } from "@mui/material";
import DataTable from "examples/Tables/DataTable";
import { formatDateEndOfDay } from "helpers/formatDate";
import { formatCurrency } from "helpers/utils";
import { IAdiantamentoEvento } from "interfaces/adiantamento";

type ITableData = {
  columns: any[];
  rows: any[];
};

interface AdiantamentosProps {
  adiantamentos: IAdiantamentoEvento[];
}

export default function Adiantamentos({ adiantamentos }: AdiantamentosProps) {
  const valueTable: ITableData = {
    columns: [
      { Header: "Descrição", accessor: "descricao", width: "20%" },
      { Header: "Dt. Pag.", accessor: "data_pagamento", width: "20%" },
      { Header: "Valor", accessor: "valor", width: "20%" },
      { Header: "Responsável", accessor: "responsavel", width: "20%" },
    ],
    rows: adiantamentos.map((adiantamento) => ({
      descricao: adiantamento.identificacaoTransacao,
      data_pagamento: formatDateEndOfDay(adiantamento.dataPagamento),
      valor: `${formatCurrency(adiantamento.valorTransacao)}`,
      responsavel: adiantamento.nomeResponsavel,
    })),
  };

  const TOTAL_ADIANTAMENTO = !adiantamentos
    ? 0
    : adiantamentos.reduce(
        (acc, adiantamento) => acc + Number(adiantamento.valorTransacao),
        0
      );

  return (
    <Card
      sx={{
        display: "flex",
        py: 2,
        px: { xs: 2, sm: 8 },
        my: 2,
      }}
    >
      <Typography variant="h4" fontWeight="bold" color="dark">
        Recebimentos de evento
      </Typography>

      <Divider />

      {TOTAL_ADIANTAMENTO > 0 ? (
        <DataTable
          table={valueTable}
          canSearch={false}
          selectedRowChanged={() => {}}
          isSorted={false}
          showTotalEntries={false}
          entriesPerPage={false}
        />
      ) : (
        <Typography
          variant="subtitle2"
          textAlign="center"
          color="InfoText"
          mt={2}
          sx={{ ml: 2 }}
        >
          Nenhum adiantamento registrado
        </Typography>
      )}
      <Typography
        variant="body2"
        color="InfoText"
        mt={2}
        fontWeight="bold"
        sx={{ ml: 2 }}
      >
        Total do adiantamento: {formatCurrency(TOTAL_ADIANTAMENTO)}
      </Typography>
    </Card>
  );
}
